module.exports = __webpack_public_path__ + "img/default-skin.b257fa9c.svg";